import * as React from "react";
import { forwardRef } from "react";
const SvgEnlargeIcon2 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.3334 2L8.00008 5.33203L4.66675 2M11.3334 13.9993L8.00008 10.5L4.66675 13.9993", stroke: "#8E8E93", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgEnlargeIcon2);
export default ForwardRef;
